import type { ComponentConfig } from './stack/ComponentConfigDocuments';

// NOTE! This is shared beteen core/api/saas so no dependencies here
export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// TODO: This is is not a unix timestamp, so maybe we should rename it?
export const timestampSeconds = () => Math.round(Date.now() / 1000);

export const ageSecondsOBSOLETE = (date: Date | number | string) => Math.abs(Math.round((Date.now() - new Date(date).getTime()) / 1000)); // TODO: This should not have Math.abs, that's bullshit
export const ageSeconds = (date: Date | number | string) => Math.round((Date.now() - new Date(date).getTime()) / 1000);

// This is pretty WIP, maybe we should use some library for this?
export const formatHumanAge = (isoTime: string | Date) => {
  const ageSeconds = Math.abs(Math.round((Date.now() - new Date(isoTime).getTime()) / 1000));
  if (ageSeconds < 100) return ageSeconds + 's';
  if (ageSeconds < 3600) return Math.round(ageSeconds / 60) + 'min';
  if (ageSeconds < 3600 * 24) return Math.round(ageSeconds / 60 / 60) + 'h';
  // TODO: maybe some format with exact time ?
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'short', timeStyle: 'short' }).format(new Date(isoTime)); // What happens in node here?
};

/**
 * Format bytes as human-readable text.
 * See: https://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable-string
 * @param bytes Number of bytes.
 * @param decimals Number of decimal places to display.
 * @param base 1000 to use metric (SI) units (powers of 1000), 1024 to use binary (IEC)
 */
export const formatHumanFilesize = (bytes: number, decimals = 0, base: 1000 | 1024 = 1024) => {
  const threshold = base;
  if (Math.abs(bytes) < threshold) {
    return bytes + ' B';
  }

  const units = base == 1000 ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10 ** decimals;

  do {
    bytes /= threshold;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= threshold && u < units.length - 1);

  return bytes.toFixed(decimals) + ' ' + units[u];
};

export const getJobRoom = (jobUUID: string) => '/job/' + jobUUID;

// Try to invent a valid label from a given name
// NOTE! has to begin with a-z, limit 42 chars, we allow end on non a-z (unlike eg. kubernetes labels)
// NOTE! Idea is that this is guaranteed to generate a valid label, even if the name is invalid
// NOTE! Label has to be valid as part of url also
export const convertNameToLabel = (name: string) => {
  const candidate =
    name
      .toLowerCase()
      .replace(/[^a-zA-Z0-9\- ]/g, '')
      .trim()
      .replace(/ /g, '-')
      .slice(0, 42) || '';
  if (!candidate.length) return 'label';
  if (!candidate.substring(0, 1).match(/^[a-z]$/)) return ('label-' + candidate).slice(0, 42);
  return candidate;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const jsonParse = <T = any>(text: any, errorValue: any = null): T => {
  try {
    return JSON.parse(text);
  } catch (error) {
    return errorValue;
  }
};

export const toTitleCase = (value: string) => {
  return value.replace(/\w\S*/g, (substring) => substring.charAt(0).toUpperCase() + substring.substring(1).toLowerCase());
};

export const createVSCodeUri = ({ protocol = 'vscode', sshUrl, path }: { protocol?: string; sshUrl: string; path: string }) =>
  encodeURI(`${protocol}://vscode-remote/ssh-remote+${sshUrl}${path}?windowId=_blank`);

export const getPlaceholderUrl = (type: 'user' | 'account' | 'project', id: number | string) =>
  `https://hotshot.b-cdn.net/${type}/${id}.svg`;

/** Test to determine if two typescript types are the same, useful when handwriting types to match zod schema */
export type AreIdentical<T, U> = T extends U ? (U extends T ? true : never) : never;
